import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app';
import type { AwNewMediaQueries } from '~~/common/utils/userInterface';
import { THROTTLE_TIMEOUT } from '~~/common/config/TimeoutConfig';
import { useUserInterfaceStore } from '~~/common/stores/userInterface';

export default defineNuxtPlugin(function () {
  const { $awEvents, $styleVariables } = useNuxtApp();
  const userInterfaceStore = useUserInterfaceStore();
  let resizeThrottle: ReturnType<typeof setTimeout> | undefined = undefined;


  const sm = window.matchMedia(`(min-width: ${$styleVariables.breakpointSm})`);
  const md = window.matchMedia(`(min-width: ${$styleVariables.breakpointMd})`);
  const lg = window.matchMedia(`(min-width: ${$styleVariables.breakpointLg})`);
  const xl = window.matchMedia(`(min-width: ${$styleVariables.breakpointXl})`);

  const mobile = window.matchMedia(`(min-width: ${$styleVariables.breakpointMobile})`);
  const tablet = window.matchMedia(`(min-width: ${$styleVariables.breakpointTablet})`);
  const desktopSmall = window.matchMedia(`(min-width: ${$styleVariables.breakpointDesktopSmall})`);
  const desktopMedium = window.matchMedia(`(min-width: ${$styleVariables.breakpointDesktopMedium})`);
  const desktopLarge = window.matchMedia(`(min-width: ${$styleVariables.breakpointDesktopLarge})`);
  const sidebar = window.matchMedia(`(min-width: ${$styleVariables.breakpointSidebar})`);

  sm.addListener(setQueries);
  md.addListener(setQueries);
  lg.addListener(setQueries);
  xl.addListener(setQueries);

  mobile.addListener(setQueries);
  tablet.addListener(setQueries);
  desktopSmall.addListener(setQueries);
  desktopMedium.addListener(setQueries);
  desktopLarge.addListener(setQueries);
  sidebar.addListener(setQueries);

  window.addEventListener('resize', throttleResize);
  window.addEventListener('orientationchange', throttleResize);

  setQueries();

  function throttleResize () {
    clearTimeout(resizeThrottle);
    resizeThrottle = setTimeout(() => {
      $awEvents.triggerEvent('throttled-resize');
    }, THROTTLE_TIMEOUT);
  }

  function setQueries () {
    const smMin = sm.matches;
    const mdMin = md.matches;
    const lgMin = lg.matches;
    const xlMin = xl.matches;

    const mobileMin = mobile.matches;
    const tabletMin = tablet.matches;
    const desktopSmallMin = desktopSmall.matches;
    const desktopMediumMin = desktopMedium.matches;
    const desktopLargeMin = desktopLarge.matches;
    const sidebarMin = sidebar.matches;

    let query = 'xl';

    if (!smMin) {
      query = 'xs';
    } else if (!mdMin) {
      query = 'sm';
    } else if (!lgMin) {
      query = 'md';
    } else if (!xlMin) {
      query = 'lg';
    }
    const newMediaQueries: AwNewMediaQueries = {
      smMin,
      mdMin,
      lgMin,
      xlMin,
      mobileMin,
      tabletMin,
      desktopSmallMin,
      desktopMediumMin,
      desktopLargeMin,
      query,
      sidebarMin,
    };
    userInterfaceStore.setMediaQueries(newMediaQueries);
  }
});
